import { Store, createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { logger } from '../middleware'
import rootReducer from '../app/root/root-reducer'
import rootSaga from '../app/root/root-saga'
import createSagaMiddleware from 'redux-saga'

const sagaMiddleware = createSagaMiddleware()
let middleware = applyMiddleware(sagaMiddleware,
    // logger
)

if (process.env.NODE_ENV !== 'production') {
    middleware = composeWithDevTools(middleware)
}

const store = createStore(rootReducer, middleware)

sagaMiddleware.run(rootSaga)

/* if (module.hot) {
    module.hot.accept('app/reducers', () => {
        const nextReducer = require('app/reducers');
        store.replaceReducer(nextReducer);
    });
} */

export default store